<template>
	<div class="small-12 addForm addResident animated fadeInRightBig border-top border-right" v-if="open_menu" v-bind:class="{ active: open_menu }">
		<div class="small-12 columns panelMenuWrapper">
			<div class="small-12 formTitle border-bottom">
				<h2 class="small-12 flex vertical-align vertical-align justify-between">
					<span class="float-left small-8">
						Create a Resident
					</span>
					<i class="material-icons-outlined transition" @click="closeMenu()">cancel</i>
				</h2>
				<div class="small-12">
					<ul class="small-12 flex vertical-align float-left attributes">
						<li>
							<p v-if="property.attributes.title">
								<b>For: </b>
								{{ property.attributes.title }}
							</p>
							<p v-else>
								<b>For: </b>
								{{ property.attributes.address.street_1 }}
							</p>
						</li>
					</ul>
				</div>
			</div>
			<div class="small-12 formBody" v-if="property">
				<div class="small-12 image borderRadius8">
					<picture class="flex small-12 justify-center vertical-align">
						<img :src="vector_image" style="width:40%" alt="Key Ring with Lots of Blues and Purples">
					</picture>
				</div>
				<div class="small-12 sectionTitle flex first">
					<h2>Resident Information</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">First Name<em class="cRed">*</em></label>
					<input type="text" name="first_name" v-model="new_resident.attributes.contact_information.first_name" @input="firstNameValidation()">
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="first_name.error">
						<small class="cRed small-12">{{first_name.title}}</small>
					</div>
				</fieldset>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Last Name<em class="cRed">*</em></label>
					<input type="text" name="first_name" v-model="new_resident.attributes.contact_information.last_name" @input="lastNameValidation()">
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="last_name.error">
						<small class="cRed small-12">{{last_name.title}}</small>
					</div>
				</fieldset>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Email</label>
					<input type="email" name="email" v-model="new_resident.attributes.contact_information.email" @input="emailValidation()">
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="email.error">
						<small class="cRed small-12">{{email.title}}</small>
					</div>
				</fieldset>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Phone</label>
					<input type="email" name="email" v-model="new_resident.attributes.contact_information.phone_number" @input="formatNumber()">
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="phone.error">
						<small class="cRed small-12">{{phone.title}}</small>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Assign Unit</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Unit<em class="cRed">*</em></label>
					<div class="small-12 selectContainer borderRadius8 flex vertical-align">
						<select name="units" class="small-12" v-model="new_resident.relationships.unit" @change="unitValidation($event)">
							<option :value="null" selected disabled>Please Choose...</option>
							<option :value="unit.id" v-for="(unit, unitIndex) in units" :selected="new_resident.relationships.unit == unit.id ? true : false" :key="unitIndex">{{unit.attributes.number}}</option>
						</select>
					</div>
					<div class="small-12 inputError flex animated fadeInDown borderRadius2" style="margin-top:5px;" v-if="unit_value.error">
						<small class="cRed small-12">{{unit_value.title}}</small>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Additional Details</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<div class="small-12 flex vertical-align checkOption">
						<div class="auto">
							<input type="checkbox" name="resides_in_unit" id="resides_in_unit" v-model="new_resident.attributes.unit.resides_in">
							<label for="resides_in_unit"></label>
						</div>
						<span>Resides in Unit?</span>
					</div>
					<div class="small-12 flex vertical-align checkOption" v-if="company && company.relationships.stripe && payment_method_set">
						<div class="auto">
							<input type="checkbox" name="enroll_resident" id="enroll_resident" v-model="new_resident.attributes.site_enrollment.enroll_resident">
							<label for="enroll_resident"></label>
						</div>
						<span>Enroll in Residents Portal?</span>
					</div>
				</fieldset>
			</div>
		</div>
		<div class="small-12 columns panelActions flex justify-center vertical-align border-top">
			<a class="blueButton small-12 flex borderRadius4 vertical-align" @click="createResidentHandler()" style="max-width:175px;" v-if="enableCreateButton">
				<i class="material-icons flex vertical-align justify-center">save</i>
				Create Resident
			</a>
			<a class="disabledButton small-12 flex borderRadius4 vertical-align" style="max-width:175px;" v-else>
				<i class="material-icons flex vertical-align justify-center">save</i>
				Create Resident
			</a>
		</div>
	</div>
</template>

<script>

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

	// Import the events
	import { GetPropertyUnits } from '@/events/units/GetPropertyUnits'
	import { GetUnit } from '@/events/units/GetUnit'
	import { CreateResident } from '@/events/residents/CreateResident'

	// Import the repository
	import { ResidentsRepository } from '@/repositories/residents/ResidentsRepository'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'AddResidentMenu',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			GetPropertyUnits,
			ResidentsRepository,
			GetUnit,
			CreateResident

		],

		/*
		**  Set the props
		*/

		props: {

			menu_action: {
				type: Boolean,
				default: false
			},

			property: {
				type: Object,
				default: () => null
			},

			user: {
				type: Object,
				default: () => null
			},

			company: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			open_menu: false,
			vector_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fkey-ring-house.svg?alt=media&token=b9321e06-a963-4d71-b596-5cee8770fe1f',
			referral_code: null,
			payment_method_set: false,
			enableCreateButton: false,
			first_name: {
				error: false,
				title: null
			},
			last_name: {
				error: false,
				title: null
			},
			email: {
				error: false,
				title: null
			},
			resides_in: {
				error: false,
				title: null
			},
			phone: {
				error: false,
				title: null
			},
			unit_value: {
				error: false,
				title: null
			},

		}),

		/*
		**  Watch em'
		*/

		watch: {

			menu_action: {

				immediate: true, // Load on created
				handler(menu_action) {

					/*
					**  Open the menu
					**  @method: @here
					*/

					if (menu_action) this.openMenu();

				}

			},

			company: {

				immediate: true, // Load on created
				handler(company) {

					/*
					**  Check if payment methods have been set
					**  @method: @here
					*/

					if (company) this.checkPaymentMethods();

				}

			},

			unit: {

				immediate: true, // Load on created
				handler(unit) {

					/*
					**  Check if payment methods have been set
					**  @method: @here
					*/

					if (unit && !unit.attributes.available) {

						/*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.unit_value.error = true;
                        this.unit_value.title = 'The unit you selected is not available to be rented.';

					} else {

						/*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.unit_value.error = false;
                        this.unit_value.title = null;

					}

				}

			},

		},

		/*
        ** Do this first
        */

        mounted() {
 
			/*
			**  Generate the referral code
			**  @method: @here
			*/

			this.generateReferralCode();

        },

        /*
		**  Set up the methods
		*/

		methods: {

			openMenu: function() {

				try {

					/*
					**  Set the prop
					**  @prop: @here
					*/

					this.open_menu = true;

					/*
					**  Reset the units
					**  @prop: @here
					*/

					this.units = [];

					/*
					**  Get the units
					**  @method: @Events/Units/GetPropertyUnits
					*/

					this.getPropertyUnitsHandler(this.$route.params.id);

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Open the add resident menu.',
						errorType: 'Application',
						section: 'Add Resident',
						uid: 'aedUnpjCe6YniGLrjvVf',
						error: e
					});

				}

			},

			checkPaymentMethods: function() {

				try {

					/*
					**  Set the prop
					**  @prop: @here
					*/

					if (this.company.attributes.settings.payment_methods.cards || this.company.attributes.settings.payment_methods.ach) this.payment_method_set = true;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Check if a payment method has been chosen.',
						errorType: 'Application',
						section: 'Add Resident',
						uid: 'xaGsxTstm7E3cFFTUMKB',
						error: e
					});

				}

			},

			closeMenu: function() {

				try {

					/*
					**  Set the prop
					**  @prop: @here
					*/

					this.open_menu = false;

					/*
					**  Set the prop
					**  @prop: @here
					*/

					this.units = [];
 
					/*
					**  Emit the event
					**  @service: @Vue
					*/

					this.$emit('closeAddResidentMenu', true);

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Close the add resident menu.',
						errorType: 'Application',
						section: 'Add Resident',
						uid: '7v2mMtbMyHzTD4hxUkLt',
						error: e
					});

				}

			},

			formatNumber: function() {

				try {

					/*
					**  Set the var
					*/

    				let x = this.new_resident.attributes.contact_information.phone_number.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

					/*
					**  Format the phone number
					*/

  					this.new_resident.attributes.contact_information.phone_number = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Format the phone number.',
						errorType: 'Application',
						section: 'Add Resident',
						uid: 'p167CBLhKmRHQPxkKgor',
						error: e
					});

				}

   			},

   			generateReferralCode: function() {

				try {

					/*
					**  Set the parts
					*/

					let firstPart = (Math.random() * 46656) | 0,
						secondPart = (Math.random() * 46656) | 0;
					 
					/*
					**  Shorten em'
					*/

					firstPart = ('000' + firstPart.toString(36)).slice(-5);
					secondPart = ('000' + secondPart.toString(36)).slice(-5);
 
					/*
					**  Set the referral code
					*/

					this.new_resident.attributes.referral.code = 'N:' + firstPart + secondPart + ':' + this.property.id;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Generate the referral code.',
						errorType: 'Application',
						section: 'Add Resident',
						uid: 'Lxvx58mNYC6Vu3lRuzHU',
						error: e
					});

				}

   			},

			firstNameValidation: function() {

				try {

					/*
					**  Validate
					**  @props: @here
					*/

                    if (this.new_resident.attributes.contact_information.first_name == '' || !this.new_resident.attributes.contact_information.first_name || this.new_resident.attributes.contact_information.first_name.length == 0) {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.first_name.error = true;
                        this.first_name.title = 'This is a required field.';

                    } else {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.first_name.error = false;
                        this.first_name.title = null;

                    }

                    /*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'First name validation.',
						errorType: 'Application',
						section: 'Add Resident',
						uid: 'Jlc7ayZxgvmtGSN9ribR',
						error: e
					});

				}

			},

			lastNameValidation: function() {

				try {

					/*
					**  Validate
					**  @props: @here
					*/

                    if (this.new_resident.attributes.contact_information.last_name == '' || !this.new_resident.attributes.contact_information.last_name || this.new_resident.attributes.contact_information.last_name.length == 0) {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.last_name.error = true;
                        this.last_name.title = 'This is a required field.';

                    } else {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.last_name.error = false;
                        this.last_name.title = null;

                    }

                    /*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Last name validation.',
						errorType: 'Application',
						section: 'Add Resident',
						uid: 'IXcQ5y4Vp9f9fGPgTeor',
						error: e
					});

				}

			},

			emailValidation: function() {

				try {

					/*
					**  Validate
					**  @props: @here
					*/

					let regEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
						emailTestResults = regEx.test(this.new_resident.attributes.contact_information.email);

                    if (this.new_resident.attributes.contact_information.email.length > 0 && !emailTestResults) {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.email.error = true;
                        this.email.title = 'Please enter in a valid email address.';

                    } else {

                        /*
                        **  Set the error props
                        **  @props: @here
                        */

                        this.email.error = false;
                        this.email.title = null;

                    }

                    /*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Email validation.',
						errorType: 'Application',
						section: 'Add Resident',
						uid: '79YNDpXkfDenNIDPUELO',
						error: e
					});

				}

			},

			unitValidation: function(event) {

				try {

					/*
					**  Get the unit
					**  @method: @Events/Units/GetUnit
					*/

					this.getUnitHandler(event.target.value);

					/*
					**  Check if we can enable the submit button
					**  @method: @here
					*/

					this.enableSubmitButtonCheck();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Unit validation.',
						errorType: 'Application',
						section: 'Add Resident',
						uid: 'YDCtLiU5G2jCO9WG7fgd',
						error: e
					});

				}

			},

			enableSubmitButtonCheck: function() {

                try {

					/*
					**  Can we enable the submit button?
					**  @props: @here
					*/

					if (this.new_resident.relationships.unit !== null && this.new_resident.relationships.unit.length !== 0 && !this.first_name.error && !this.last_name.error && !this.email.error && !this.resides_in.error && !this.phone.error && !this.unit_value.error) {

                        /*
						**  Enable the create button
						**  @prop: @here
						*/

						this.enableCreateButton = true;

					} else {

						/*
						**  Disable the create button
						**  @prop: @here
						*/

						this.enableCreateButton = false;

					}

                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to perform submit button check.',
						errorType: 'Application',
						section: 'Add Resident',
						uid: 'cpX8c9vmXvPq4bCjlDZE',
						error: e
					});

                }

            }

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		}

	}

</script>